import React, { useState } from 'react';
import FormBuilder from './FormBuilder';
import './FormBuilderWrapper.css';

const FormBuilderWrapper = ({ onClose }) => {
    const [isMinimized, setIsMinimized] = useState(false);

    return (
        <div className={`form-builder-wrapper ${isMinimized ? 'minimized' : ''}`}>
            <div className="form-builder-header-controls">
                <div className="window-controls">
                    <button 
                        className="control-btn minimize-btn"
                        onClick={() => setIsMinimized(!isMinimized)}
                        title={isMinimized ? 'Maximize' : 'Minimize'}
                    >
                        {isMinimized ? '🔺' : '🔻'}
                    </button>
                    <button 
                        className="control-btn close-btn"
                        onClick={onClose}
                        title="Close Form Builder"
                    >
                        ✕
                    </button>
                </div>
                <h1 className="form-builder-title">
                    🚀 Advanced Form Builder
                </h1>
            </div>
            
            {!isMinimized && (
                <div className="form-builder-content-wrapper">
                    <FormBuilder />
                </div>
            )}
        </div>
    );
};

export default FormBuilderWrapper;
